import {
  COMMODITIES_QUERY,
  PACKAGE_TEMPERATURES_QUERY,
  PACKAGE_TYPES_QUERY,
  TEMPERATURE_DEVICES_QUERY,
} from '../../../../app/graphql/adminQueries';

export const ADMIN_PICKLIST_SECTIONS = {
  commodityTypes: {
    routeKey: 'commodityTypes',
    query: COMMODITIES_QUERY,
    dataKey: 'commodities',
    itemName: 'commodityTypesSettings',
    titleId: 'admin.accountManagement.accountDetail.commodityTypes',
    titlesPrefix: 'admin.accountManagement.accountDetail.commodity',
    icon: 'shapes',
  },
  temperatureDevices: {
    routeKey: 'temperatureDevices',
    query: TEMPERATURE_DEVICES_QUERY,
    dataKey: 'temperatureDevices',
    itemName: 'tempDevicesSettings',
    titleId: 'admin.accountManagement.accountDetail.temperatureDevices',
    titlesPrefix: 'admin.accountManagement.accountDetail.temperature',
    icon: 'temperature-high',
  },
  packageTypes: {
    routeKey: 'packageTypes',
    query: PACKAGE_TYPES_QUERY,
    dataKey: 'packageTypes',
    itemName: 'packageTypesSettings',
    titleId: 'admin.accountManagement.accountDetail.packageTypes',
    titlesPrefix: 'admin.accountManagement.accountDetail.packageTypes',
    icon: 'boxes',
  },
  packageTemperatures: {
    routeKey: 'packageTemperatures',
    query: PACKAGE_TEMPERATURES_QUERY,
    dataKey: 'packageTemperatures',
    itemName: 'packageTempSettings',
    titleId: 'admin.accountManagement.accountDetail.packageTemps',
    titlesPrefix: 'admin.accountManagement.accountDetail.packTemp',
    icon: 'location-arrow',
  },
};
